import { Search } from "@mui/icons-material";
import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const NotificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.notifications}?search=${search}&pageNumber=${page}`,
        method: "GET",
      }),
    }),

    addNotification: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addNotifications,
        method: "POST",
        body,
      }),
    }),

    deleteMyNotification: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteMyNotifications}?Id=${id}`,
        method: "DELETE",
      }),
    }),

    getBroadcastNotifications: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.broadcastNotifications}?search=${search}&pageNumber=${page}`,
        method: "GET",
      }),
    }),

    deleteBroadcastNotifications: builder.query<CommonResponse, { id: string }>(
      {
        query: ({ id }) => ({
          url: `${END_POINTS.deleteBroadcastNotifications}?Id=${id}`,
          method: "DELETE",
        }),
      }
    ),

    getDeviceSpecificUsers: builder.query<
      CommonResponse,
      { deviceType: string }
    >({
      query: ({ deviceType }) => ({
        url: `${END_POINTS.deviceSpecificUsers}?devicetype=${deviceType}`,
        method: "GET",
      }),
    }),

    getBroadcastMembers: builder.query<
      CommonResponse,
      { id: string | undefined; page: number; search: string }
    >({
      query: ({ id, page, search }) => ({
        url: `${END_POINTS.broadcastMembers}/${id}?pageNumber=${page}&pageSize=10&search=${search}`,
        method: "GET",
      }),
    }),

    getActiveOffers: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.activeOffers}`,
        method: "GET",
      }),
    }),

    getUserNotifications: builder.query<
      CommonResponse,
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.usersNotification}?pageNumber=${page}&pageSize=10&search=${search}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetNotificationsQuery,
  useAddNotificationMutation,
  useLazyDeleteMyNotificationQuery,
  useLazyGetBroadcastNotificationsQuery,
  useLazyDeleteBroadcastNotificationsQuery,
  useLazyGetDeviceSpecificUsersQuery,
  useLazyGetBroadcastMembersQuery,
  useLazyGetActiveOffersQuery,
  useLazyGetUserNotificationsQuery,
} = NotificationApi;
